import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors";
import {
    pageTitles,
} from "../shared/constants";
import { useEffect, useState } from "react";
import { AppRoutes } from "../routes/route.path";
import { useNavigate } from "react-router-dom";
import { ProfileModel } from "../../models/profile.model";
import { UserService } from "../../services/UserService";
import { setHeaderTitle } from "../../helpers/header.helper"
import { encryptString } from "../../services/hmac-encryption-decryption";
import Config from "../../config";
import { AuthService } from "../../services/AuthService";
import AnimateLoaderComponent from "../shared/loaders/animate-loader.component";
import FalkonSignLoader from "../shared/loaders/falkon_sign_loader.json";

const FalkonDocsComponent = () => {
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);

    const [iframeSrc, setIframeSrc] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const navigate = useNavigate();

    const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage();

    const OrgName = useSelector(selector.OrganizationName);

    const navigateToEsign = async () => {
        const token = AuthService.getToken();
        const tokenEncrypted = await encryptString(Config.FILE_DETAILS_ENCRYPTION_KEY, token.access_token);
        const firstName = await encryptString(Config.FILE_DETAILS_ENCRYPTION_KEY, Profile.FirstName);
        const lastName = await encryptString(Config.FILE_DETAILS_ENCRYPTION_KEY, Profile.LastName);
        const orgNameEncripted = await encryptString(Config.FILE_DETAILS_ENCRYPTION_KEY, OrgName);
        const PhoneNumberId = await encryptString(Config.FILE_DETAILS_ENCRYPTION_KEY, Profile.PhoneNumberID);
        const PhoneNumber = await encryptString(Config.FILE_DETAILS_ENCRYPTION_KEY, Profile.PhoneNumber);

        const queryParams = new URLSearchParams({
            value6: PhoneNumber,
            value5: PhoneNumberId,
            value4: orgNameEncripted,
            value2: firstName,
            value3: lastName,
            value1: tokenEncrypted,
        }).toString();

        // window.open(`${Config.ESIGN_APP_URL}/auth/callback?${queryParams}`, "_blank", "noopener,noreferrer");
        // navigate(AppRoutes.DASHBOARD)
        setIframeSrc(`${Config.ESIGN_APP_URL}/auth/callback?${queryParams}`)
    }

    useEffect(() => {
        navigateToEsign()
        // LoadSecureDocs(dispatch, Profile.ID);
        setHeaderTitle(pageTitles.FALKON_SIGN);
    }, []);

    return (
        <>
            {
                isLoading &&
                <div className={`w-p-100 h-p-100 d-flex justify-center align-center ${IsDarkMode ? "bg-color-primary" : "bg-color-secondary"}`}>
                    <div style={{ margin: "auto", width: "16rem" }}>
                        {<div className={`w-p-100 h-v-105 d-flex flex-direction justify-start align-start`}>
                            <AnimateLoaderComponent LoaderAnimation={FalkonSignLoader} className={"w-28 mt-4"} />
                        </div>}
                    </div>
                </div>
            }

            <iframe src={iframeSrc} className="w-p-100 h-p-100 b-none" onLoad={() => { setIsLoading(false) }} />
        </>
    );
};

export default FalkonDocsComponent;